import React,
{
    useState
} from 'react';
import {
    Grid,
    Button,
    makeStyles
} from '@material-ui/core';
import BackDrop from './Common/Images/backdrop.png';
import Logo from './Common/Images/logo.png';
import LogoType from './Common/Images/logoType.png';

const WelcomeSection = (props: any) => {

    const classes = useStyle();
    return (
        <Grid
            container
            className={classes.main}
        >
            <Grid
                item
            >
                <img src={BackDrop} className={classes.backDrop}/>
            </Grid>

            <Grid
                xs={12}
                item
                container
                className={classes.container}
                justify={"center"}
                alignItems={'center'}
            >
                <Grid
                    xs={12}
                    item
                    justify={"center"}
                    container
                >

                    <img src={Logo} className={classes.logo} />


                    <img src={LogoType} className={classes.logoType} />

                    <Button
                        variant={'outlined'}
                        className={classes.button}
                        size={'large'}
                        onClick={() => {}}
                    >
                        Take the tour
                    </Button>

                </Grid>


            </Grid>

        </Grid>
    )
};

const useStyle = makeStyles({
    main: {
        width: '100%',
        height: '100%',
    },
    container: {
        background: 'rgba(4,106,56,0.65)',
        width: '100%',
        height: '100%',
        zIndex: 100,
    },
    backDrop: {
        position: 'absolute',
        zIndex: 0,
        width: '100%',
        left: '50%',
        transform: 'translate(-50%, 0)'
    },
    logo: {
        // width: '188px',
        // left: '50%',
        height:'142px'
    },
    logoType: {
        marginTop: 30,
        width: '75%',
        marginBottom: 120,
    },
    button: {
        color: 'white',
        borderColor: 'white',
        borderWidth: 3,

    }

});

export default WelcomeSection;